/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Theatre_Film_Media23Inputs */

const en__field__enum_additionalstudyinterests_study_theatre_film_media23 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Theatre_Film_Media23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theatre, Film and Media Studies`)
};

const de__field__enum_additionalstudyinterests_study_theatre_film_media23 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Theatre_Film_Media23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theater-, Film- u. Medienwissenschaft`)
};

/**
* | output |
* | --- |
* | "Theatre, Film and Media Studies" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Theatre_Film_Media23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_theatre_film_media23 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Theatre_Film_Media23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Theatre_Film_Media23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_theatre_film_media23(inputs)
	return de__field__enum_additionalstudyinterests_study_theatre_film_media23(inputs)
});
export { _field__enum_additionalstudyinterests_study_theatre_film_media23 as "_field__enum_additionalStudyInterests_STUDY_THEATRE_FILM_MEDIA" }